import React, { useState, useEffect } from "react";

//REACT-BOOTSTRAP COMPONENTS
import Form from "react-bootstrap/Form";
import { FormCheck } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import "./Types-Dropdown.scss";

const TypesDropdown = ({ toggleRow, selectedRows, removeMSOffice, typesDropdown }) => {
  const [showDropdown, setShowDropdown] = useState(true);
  const [wordSelected, setWordSelected] = useState(false);
  const [excelSelected, setExcelSelected] = useState(false);
  const [powerpointSelected, setPowerPointSelected] = useState(false);
  const [standardChecked, setStandardChecked] = useState(false)

  useEffect(() => {
    if (selectedRows.length === 0) {
      setWordSelected(false);
      setExcelSelected(false);
      setPowerPointSelected(false);
      setStandardChecked(false);
    } else {
      for (let i = 0; i < selectedRows.length; i++) {
        switch (selectedRows[i]) {
          case "Word":
            setWordSelected(true);
            break;
          case "Excel":
            setExcelSelected(true);
            break;
          case "PowerPoint":
            setPowerPointSelected(true);
            break;
          case "Standard Task":
            setStandardChecked(true);
            break;
        }
      }
    }
  }, [toggleRow, selectedRows, removeMSOffice, typesDropdown]);

  const dropdown = () => {
    typesDropdown(!showDropdown)
    setShowDropdown(!showDropdown);
  };

  const toggleMSOffice = (checked) => {
    if(!checked){
      setWordSelected(false)
      setExcelSelected(false)
      setPowerPointSelected(false)
      removeMSOffice()
    }
    else{
      let msOffice = ['Word','Excel','PowerPoint']
      //CHECKS IF WORD/EXCEL/POWERPOINT IS ALREADY INSIDE BEFORE ADDING THEM
      selectedRows.forEach(element => {
        if(msOffice.includes(element)){
          msOffice.splice(msOffice.indexOf(element), 1)
        }
      });
      setWordSelected(true)
      setExcelSelected(true)
      setPowerPointSelected(true)
      toggleRow(msOffice, checked)
    }
  }

  const toggleAll = (checked) => {
    if(checked){
      setWordSelected(true)
      setExcelSelected(true)
      setPowerPointSelected(true)
      setStandardChecked(true)
      toggleRow(['Word','Excel','PowerPoint','Standard Task'], checked)
    }
    else{
      setWordSelected(false)
      setExcelSelected(false)
      setPowerPointSelected(false)
      setStandardChecked(false)
      toggleRow([], checked)
    }
  }

  return (
    <Form.Group className="types-dropdown-container">
      <Dropdown.Divider style={{ width: "470px" }}></Dropdown.Divider>
      <Form.Check className={'types-dropdown-row'}>
        <FormCheck.Input
          type="checkbox"
          checked= {powerpointSelected && wordSelected && excelSelected && standardChecked}
          onChange={(e) =>
              toggleAll(e.target.checked)
          }
        />
        <div className={'types-dropdown-ms-office'}>All Types</div>
      </Form.Check>
      
      <Dropdown.Divider style={{ width: "470px" }}></Dropdown.Divider>
      <Form.Check className={'types-dropdown-row'}>
        <FormCheck.Input
          type="checkbox"
          onChange={(e) =>
              toggleMSOffice(e.target.checked)
          }
          checked = {powerpointSelected || wordSelected || excelSelected}
        />
        {
          //ADD ONCLICK CALL DROPDOWN
        }
        <div onClick={() => dropdown()} className={'types-dropdown-ms-office'}>▼ MS Office Task</div>
      </Form.Check>
      {showDropdown ? (
        <div className="types-dropdown-suboption-container">
          <Dropdown.Divider style={{ "width": "470px", "left":"0px","position":"absolute"}}></Dropdown.Divider>
          <Form.Check
            className={'types-dropdown-row-child'}
            type="checkbox"
            label="Word"
            checked = {wordSelected}
            onChange={(e) => {setWordSelected(!wordSelected); toggleRow("Word", e.target.checked)}}
          />
          <Dropdown.Divider style={{ "width": "470px", "left":"-9px","position":"relative"}}></Dropdown.Divider>
          <Form.Check
            className={'types-dropdown-row-child'}
            type="checkbox"
            label="Excel"
            checked = {excelSelected}
            onChange={(e) => {setExcelSelected(!excelSelected); toggleRow("Excel", e.target.checked)}}
          />
          <Dropdown.Divider style={{ "width": "470px", "left":"-9px","position":"relative"}}></Dropdown.Divider>
          <Form.Check
            className={'types-dropdown-row-child'}
            type="checkbox"
            label="PowerPoint"
            checked = {powerpointSelected}
            onChange={(e) => {setPowerPointSelected(!powerpointSelected); toggleRow("PowerPoint", e.target.checked)}}
          />
        </div>
      ) : (
        <></>
      )}
      <Dropdown.Divider></Dropdown.Divider>
      <Form.Check
        className={'types-dropdown-row'}
        type="checkbox"
        label="Standard Task"
        checked={standardChecked}
        onChange={(e) => {setStandardChecked(!standardChecked); toggleRow("Standard Task", e.target.checked)}}
      />

      <Dropdown.Divider></Dropdown.Divider>
      {/* JIRA TASK, IMPLEMENT LATER
      <Form.Check
        className={'types-dropdown-row'}
        disabled
        type="checkbox"
        label="Jira Task"
        onChange={(e) => toggleRow("Jira Task", e.target.checked)}
      />
      <Dropdown.Divider></Dropdown.Divider>
      */}
    </Form.Group>
  );
};

export default TypesDropdown;
